import { render, staticRenderFns } from "./EventDynamic.vue?vue&type=template&id=4a7c39a3&scoped=true&"
import script from "./EventDynamic.vue?vue&type=script&lang=js&"
export * from "./EventDynamic.vue?vue&type=script&lang=js&"
import style0 from "./EventDynamic.vue?vue&type=style&index=0&id=4a7c39a3&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7c39a3",
  null
  
)

export default component.exports